function meetingRange(meeting) {
  const start = new Date(meeting.start_at).getTime();
  const end = new Date(meeting.end_at).getTime();
  return { start, end: Math.max(end, start + 1) };
}

/**
 * Calcula left/width/zIndex (em %) para eventos sobrepostos no tempo, no
 * estilo Google Calendar: dentro de um cluster de conflito, os cards ficam
 * em cascata da esquerda para a direita — mais longo primeiro (empate: mais
 * antigo primeiro) — cada um cobrindo o anterior e deixando só uma fatia
 * visível à esquerda. Os da direita ficam por cima (z-index maior).
 */
export function computeOverlapLayout(meetings) {
  const sorted = [...meetings].sort((a, b) => {
    const rangeA = meetingRange(a);
    const rangeB = meetingRange(b);
    return rangeA.start - rangeB.start;
  });

  const layout = new Map();
  let cluster = [];
  let clusterEnd = -Infinity;

  const flushCluster = () => {
    if (!cluster.length) return;
    const ordered = [...cluster].sort((a, b) => {
      const rangeA = meetingRange(a);
      const rangeB = meetingRange(b);
      const durationDiff =
        rangeB.end - rangeB.start - (rangeA.end - rangeA.start);
      if (durationDiff !== 0) return durationDiff;
      return rangeA.start - rangeB.start;
    });

    const count = ordered.length;
    const TARGET_STEP = 28;
    const MAX_TOTAL_OFFSET = 70;
    const step =
      count > 1 ? Math.min(TARGET_STEP, MAX_TOTAL_OFFSET / (count - 1)) : 0;
    const width = 100 - step * (count - 1);

    ordered.forEach((meeting, index) => {
      layout.set(meeting.id, {
        left: step * index,
        width,
        zIndex: 10 + index,
      });
    });

    cluster = [];
    clusterEnd = -Infinity;
  };

  sorted.forEach(meeting => {
    const { start, end } = meetingRange(meeting);
    if (cluster.length && start >= clusterEnd) {
      flushCluster();
    }
    cluster.push(meeting);
    clusterEnd = Math.max(clusterEnd, end);
  });
  flushCluster();

  return layout;
}
